const loading = "학습 콘텐츠를 불러오는 중...";
const loadingContent = "콘텐츠를 불러오는 중...";
const errorOccurred = "오류 발생";
const cannotLoadContent = "콘텐츠를 불러올 수 없습니다.";
const errorLoadingContent = "콘텐츠를 불러오는 중 오류가 발생했습니다.";
const lectureNotFound = "강의를 찾을 수 없습니다";
const backToList = "목록으로 돌아가기";
const goBack = "돌아가기";
const exit = "나가기";
const previous = "이전";
const next = "다음";
const nextStep = "다음 단계로";
const nextTo = "다음으로";
const start = "시작하기";
const close = "닫기";
const dashboard = {
  warmup: "워밍업",
  warmupQuiz: "워밍업 퀴즈",
  warmupDescription: "학습 전 두뇌 스트레칭",
  warmupFullDescription: "학습 전 간단한 퀴즈로 준비하세요",
  test: "테스트",
  testQuiz: "확인 퀴즈",
  testDescription: "배운 내용 완전 정복",
  testFullDescription: "학습 내용을 확인해보세요",
  wrapup: "Wrapup",
  wrapupQuiz: "마무리 퀴즈",
  wrapupDescription: "심화 학습 문제",
  wrapupFullDescription: "학습을 마무리하는 종합 퀴즈입니다",
  aiq: "AIQ",
  aiqDescription: "AI 기반 맞춤 문제",
  videoLesson: "영상 학습",
  videoLecture: "영상 강의",
  videoDescription: "영상으로 개념을 익히세요",
  videoDescriptionWithDuration: "{{minutes}}분 영상으로 개념을 익히세요",
  videoNotProvided: "영상이 제공되지 않습니다",
  videoAfterWarmup: "워밍업 완료 후 시청 가능",
  masterKeyConcepts: "핵심 개념 마스터하기",
  noQuestionsAvailable: "준비된 문제가 없습니다",
  correctAnswersSummary: "{{correct}}/{{total}} 정답 ({{score}}점)",
  startTitle: "{{title}} 시작",
  retakeAll: "전체 다시 풀기",
  incorrectOnly: "오답 문제만",
  retryIncorrect: "틀린 문제 다시 풀기",
  retryIncorrectOnly: "틀린 문제만 다시 풀기",
  mustCompleteWarmup: "워밍업을 먼저 끝내야 합니다",
  warmupIncluded: "워밍업 포함",
  warmupNotIncluded: "워밍업 없음",
  videoIncluded: "영상 강의 포함",
  videoNotIncluded: "영상 강의 없음",
  reviewIncluded: "복습 문제 포함",
  reviewNotIncluded: "복습 문제 없음",
  wrapupIncluded: "Wrapup 포함",
  aiqIncluded: "AIQ 포함",
  completedBadge: "완료",
  lockedBadge: "잠김"
};
const rewatch = "다시 보기";
const completed = {
  title: "학습 완료!",
  titleWithEmoji: "학습 완료! 🎉",
  subtitle: '"{{title}}" 학습을 완료했습니다',
  successMessage: "학습을 성공적으로 마쳤습니다.",
  results: "학습 결과",
  videoWatched: "영상 시청",
  quizScore: "퀴즈 점수",
  completionTime: "완료 시간",
  scorePoints: "{{score}}점",
  nextLearning: "다음 학습으로",
  restudy: "다시 학습하기",
  backToLearningList: "학습 목록으로",
  encouragement: "꾸준한 학습이 실력 향상의 비결입니다! 💪"
};
const progress = {
  learningProgress: "학습 진행률",
  viewingCompleted: "시청 완료",
  percentWatched: "{{percent}}% 시청",
  percentRequired: "({{percent}}% 필요)",
  videoCompletedMessage: "🎉 영상 시청을 완료했습니다!",
  minuteVideo: "{{minutes}}분 영상"
};
const tips = {
  title: "💡 학습 팁",
  warmup: "• 워밍업 퀴즈로 현재 이해도를 확인해보세요",
  video: "• 영상을 끝까지 시청하면 학습이 기록됩니다",
  review: "• 확인 퀴즈로 배운 내용을 복습하세요",
  wrapup: "• 마무리 퀴즈로 학습을 완성하세요"
};
const video = {
  notReady: "영상이 준비되지 않았습니다",
  notFound: "영상을 찾을 수 없습니다",
  noVideoForContent: "이 콘텐츠에 연결된 영상이 없습니다.",
  noIdProvided: "영상 ID가 제공되지 않았습니다",
  cannotLoadInfo: "영상 정보를 불러올 수 없습니다",
  urlNotFound: "영상 URL을 찾을 수 없습니다. 잠시 후 다시 시도해주세요.",
  loadError: "영상 정보를 불러오는 중 오류가 발생했습니다",
  networkError: "네트워크 오류가 발생했습니다. 재시도 중...",
  cannotPlay: "영상 재생 중 오류가 발생했습니다",
  hlsNotSupported: "이 브라우저에서는 HLS 영상을 지원하지 않습니다",
  retry: "다시 시도",
  normal: "보통"
};
const playerKo = {
  loading,
  loadingContent,
  errorOccurred,
  cannotLoadContent,
  errorLoadingContent,
  lectureNotFound,
  backToList,
  goBack,
  exit,
  previous,
  next,
  nextStep,
  nextTo,
  start,
  close,
  dashboard,
  rewatch,
  completed,
  progress,
  tips,
  video
};
export {
  backToList,
  cannotLoadContent,
  close,
  completed,
  dashboard,
  playerKo as default,
  errorLoadingContent,
  errorOccurred,
  exit,
  goBack,
  lectureNotFound,
  loading,
  loadingContent,
  next,
  nextStep,
  nextTo,
  previous,
  progress,
  rewatch,
  start,
  tips,
  video
};
//# sourceMappingURL=player.json.js.map
